export const dataLayerPush = (
  eventName: string,
  userId: string,
  optionalProp?: {
    fieldName: string;
    fieldValue: string | Array<string> | number | Object;
  }
) => {
  let dataLayerObject: Record<string, any> = {
    event: eventName,
    userId: userId,
  };

  if (optionalProp) {
    dataLayerObject[optionalProp.fieldName] = optionalProp.fieldValue;
  }

  const isInIframe = window.self !== window.top;

  if (isInIframe) {
    window.parent.postMessage(
      {
        type: 'ANALYTICS_EVENT',
        payload: dataLayerObject,
      },
      '*'
    );
  } else {
    if (window.dataLayer) {
      window.dataLayer.push(dataLayerObject);
    } else {
      console.warn('⚠️ dataLayer no disponible');
    }
  }
};
